<template>
  <div class="benefit-item">
    <template v-if="refundRulesExtra?.length">
      <div v-for="(item, index) in refundRulesExtra" :key="index">
        <div v-if="item.region?.includes('Domestic') && !ifInternational" v-html="item.info"></div>
        <div v-if="item.region?.includes('International') && ifInternational" v-html="item.info"></div>
        <div v-if="item.region?.includes('ALL')" v-html="item.info"></div>
      </div>
    </template>
    <!-- 未配置cms权益模块的展示 -->
    <template v-else>
      <div
          v-if="!ifInternational"
          class="remark-notice"
        >
          <l8-icon class="l8-icon" type="icon-jinggaoicon" />
          以上退改签费用标准仅供参考，请以实际情况为准。<br />
          <l8-icon class="l8-icon" type="icon-jinggaoicon" />
          客票变更时，需同时收取票价价差和变更手续费。
        </div>
        <div v-else>
          <span class="primary-color" >1.如您购买往返客票，退改费将按照去回程中更严格一方的标准收取，具体请以实际审核退改金额为准。</span >
          <br />
          2.因汇率等时有变动，以上手续费仅供参考，具体可退税费需人工核实，以实际审核退改金额为准。<br />
          <span class="primary-color" >另: 儿童变更/退票手续费按照成人相应规定执行。 不占座婴儿变更/退票免收手续费。</span >
          <br />
        </div>
    </template>
  </div>
</template>

<script>
const { cms, airline } = window.__MICRO_ROOT__ ?? {}

export default {
  props: {
    ifInternational: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      airline,
      benefitRules: [],
      refundRulesExtra: []
    }
  },
  computed: {},
  methods: {
    async getCmsData () {
      try {
        // const pageCmsData = this.pageCmsData = (await cms?.getPageData()) ?? {}
        // const benefitRules = get(pageCmsData, 'rights-configs.list') || []
        const { benefits } = await cms.getData({
          items: ['common.benefits']
        })

        const benefitRules = benefits?.list ?? []

        // 获取所有 moduleId 的列表
        const moduleIds = benefitRules
          .find(item => item.code === 'REFUND_FEE')
          ?.extras
          ?.map(item => item.moduleId) || []

        // 使用 map 和 Promise.all 来获取所有模块的信息
        const extraInfos = await Promise.all(
          moduleIds.map(async moduleId => {
            const info = await cms.fetchItems([moduleId])
            return { moduleId, content: info[moduleId]?.content }
          })
        )

        // 更新 refundRulesExtra 数组
        const refundRulesExtra = benefitRules.find(item => item.code === 'REFUND_FEE')?.extras || []
        refundRulesExtra.forEach((item, index) => {
          const matchedInfo = extraInfos.find(info => info.moduleId === item.moduleId)
          if (matchedInfo) {
            refundRulesExtra[index].info = matchedInfo.content
          }
        })

        this.refundRulesExtra = refundRulesExtra
      } catch (error) {
        console.log('error >>>> ', error)
      }
    }
  },
  mounted () {
    this.getCmsData()
  }
}
</script>

<style lang="less">
</style>
